import React from "react";
import { useSelector } from "react-redux";
import { getTexts } from "../../../reducers/selectors";

import style from "./Footer.scss";

export const Footer = () => {
  const texts = useSelector(getTexts);

  return (
    <div className={style.footer}>
      <img className={style.logoButton} src="/img/logo-blanco.png" alt="logo" />

      <span className={style.text}>
        <p>{texts.notes.footer_line_1}</p>
        <p>{texts.notes.footer_line_2}</p>
      </span>
    </div>
  );
};
